import React, { useState } from 'react';

interface LinkItem {
  url: string;
  description: string;
  category: string;
  status?: 'active' | 'external' | 'documentation' | 'internal';
  method?: string;
  file?: string;
}

export const LinksDirectory: React.FC = () => {
  const [selectedCategory, setSelectedCategory] = useState<string>('all');
  const [searchTerm, setSearchTerm] = useState('');

  const links: LinkItem[] = [
    // Frontend Routes (React)
    {
      url: 'http://localhost:3000/',
      description: 'Main shipping school app dashboard',
      category: 'Frontend Routes',
      status: 'active'
    },
    {
      url: 'http://localhost:3000/architecture',
      description: 'Interactive architecture diagram of the full system',
      category: 'Frontend Routes',
      status: 'active'
    },
    {
      url: 'http://localhost:3000/structure',
      description: 'Project structure visualization',
      category: 'Frontend Routes',
      status: 'active'
    },
    {
      url: 'http://localhost:3000/ses-quest',
      description: 'Gamified AWS SES setup tutorial',
      category: 'Frontend Routes',
      status: 'active'
    },
    {
      url: 'http://localhost:3000/ses-real',
      description: 'Real AWS SES setup with credential storage',
      category: 'Frontend Routes',
      status: 'active'
    },
    {
      url: 'http://localhost:3000/aws-signup',
      description: 'AWS account creation wizard',
      category: 'Frontend Routes',
      status: 'active'
    },
    {
      url: 'http://localhost:3000/iam-setup',
      description: 'IAM Permission Palace - Step-by-step IAM user creation',
      category: 'Frontend Routes',
      status: 'active'
    },
    {
      url: 'http://localhost:3000/domains',
      description: 'Domain management center for AWS SES',
      category: 'Frontend Routes',
      status: 'active'
    },
    {
      url: 'http://localhost:3000/send-email',
      description: 'Email sender interface with templates',
      category: 'Frontend Routes',
      status: 'active'
    },
    {
      url: 'http://localhost:3000/files',
      description: 'Client folder manager (original version)',
      category: 'Frontend Routes',
      status: 'active'
    },
    {
      url: 'http://localhost:3000/share/:linkId',
      description: 'Share access portal for file recipients',
      category: 'Frontend Routes',
      status: 'active'
    },
    {
      url: 'http://localhost:3000/folder-steps',
      description: 'Detailed step-by-step folder creation visualization',
      category: 'Frontend Routes',
      status: 'active'
    },
    {
      url: 'http://localhost:3000/links',
      description: 'This links directory page',
      category: 'Frontend Routes',
      status: 'active'
    },

    // API Health & Info Endpoints
    {
      url: 'http://localhost:8787/api/health',
      description: 'API health check endpoint',
      category: 'API - System',
      status: 'active',
      method: 'GET'
    },
    {
      url: 'http://localhost:8787/api/hello',
      description: 'Hello world endpoint showing available features',
      category: 'API - System',
      status: 'active',
      method: 'GET'
    },
    {
      url: 'http://localhost:8787/api/structure',
      description: 'Project structure and architecture info',
      category: 'API - System',
      status: 'active',
      method: 'GET'
    },
    {
      url: 'http://localhost:8787/api/users',
      description: 'List users from D1 database',
      category: 'API - System',
      status: 'active',
      method: 'GET'
    },

    // AWS Credential Management
    {
      url: 'http://localhost:8787/api/aws/credentials',
      description: 'Store AWS credentials (POST) or get credentials (GET)',
      category: 'API - AWS Credentials',
      status: 'active',
      method: 'GET/POST'
    },
    {
      url: 'http://localhost:8787/api/aws/ses/progress',
      description: 'Get SES setup progress',
      category: 'API - AWS Credentials',
      status: 'active',
      method: 'GET'
    },
    {
      url: 'http://localhost:8787/api/aws/ses/progress/:questId',
      description: 'Update quest progress',
      category: 'API - AWS Credentials',
      status: 'active',
      method: 'PUT'
    },
    {
      url: 'http://localhost:8787/api/aws/verify',
      description: 'Verify AWS credentials',
      category: 'API - AWS Credentials',
      status: 'active',
      method: 'POST'
    },

    // Email Sending
    {
      url: 'http://localhost:8787/api/email/send',
      description: 'Send single email via AWS SES',
      category: 'API - Email',
      status: 'active',
      method: 'POST'
    },
    {
      url: 'http://localhost:8787/api/email/send-template',
      description: 'Send templated email',
      category: 'API - Email',
      status: 'active',
      method: 'POST'
    },
    {
      url: 'http://localhost:8787/api/email/send-bulk',
      description: 'Send bulk emails',
      category: 'API - Email',
      status: 'active',
      method: 'POST'
    },
    {
      url: 'http://localhost:8787/api/email/quota',
      description: 'Get SES sending quota',
      category: 'API - Email',
      status: 'active',
      method: 'GET'
    },
    {
      url: 'http://localhost:8787/api/email/verify-address',
      description: 'Verify email address for sending',
      category: 'API - Email',
      status: 'active',
      method: 'POST'
    },
    {
      url: 'http://localhost:8787/api/email/test',
      description: 'Test email configuration',
      category: 'API - Email',
      status: 'active',
      method: 'POST'
    },

    // Domain Management
    {
      url: 'http://localhost:8787/api/domains',
      description: 'List domains (GET) or add domain (POST)',
      category: 'API - Domains',
      status: 'active',
      method: 'GET/POST'
    },
    {
      url: 'http://localhost:8787/api/domains/:domainId/dns',
      description: 'Get DNS records for domain',
      category: 'API - Domains',
      status: 'active',
      method: 'GET'
    },
    {
      url: 'http://localhost:8787/api/domains/:domainId/verify',
      description: 'Verify domain ownership',
      category: 'API - Domains',
      status: 'active',
      method: 'POST'
    },
    {
      url: 'http://localhost:8787/api/domains/:domainId',
      description: 'Delete domain',
      category: 'API - Domains',
      status: 'active',
      method: 'DELETE'
    },
    {
      url: 'http://localhost:8787/api/domains/:domainId/stats',
      description: 'Get domain statistics',
      category: 'API - Domains',
      status: 'active',
      method: 'GET'
    },

    // Event Handling
    {
      url: 'http://localhost:8787/api/events/ses-webhook',
      description: 'AWS SNS webhook for SES events',
      category: 'API - Events',
      status: 'active',
      method: 'POST'
    },
    {
      url: 'http://localhost:8787/api/events/message/:messageId',
      description: 'Get events for specific message',
      category: 'API - Events',
      status: 'active',
      method: 'GET'
    },
    {
      url: 'http://localhost:8787/api/events/stats',
      description: 'Get event statistics',
      category: 'API - Events',
      status: 'active',
      method: 'GET'
    },
    {
      url: 'http://localhost:8787/api/events/suppression-list',
      description: 'Get email suppression list',
      category: 'API - Events',
      status: 'active',
      method: 'GET'
    },
    {
      url: 'http://localhost:8787/api/events/check-suppression/:email',
      description: 'Check if email is suppressed',
      category: 'API - Events',
      status: 'active',
      method: 'GET'
    },
    {
      url: 'http://localhost:8787/api/events/stream/:domainId',
      description: 'Stream events for domain (SSE)',
      category: 'API - Events',
      status: 'active',
      method: 'GET'
    },

    // OTP
    {
      url: 'http://localhost:8787/api/otp/send',
      description: 'Send OTP code to email',
      category: 'API - OTP',
      status: 'active',
      method: 'POST'
    },
    {
      url: 'http://localhost:8787/api/otp/verify',
      description: 'Verify OTP code',
      category: 'API - OTP',
      status: 'active',
      method: 'POST'
    },
    {
      url: 'http://localhost:8787/api/otp/resend',
      description: 'Resend OTP code',
      category: 'API - OTP',
      status: 'active',
      method: 'POST'
    },

    // File Management
    {
      url: 'http://localhost:8787/api/simple/folders/create',
      description: 'Create client folder in R2 storage',
      category: 'API - Files',
      status: 'active',
      method: 'POST'
    },
    {
      url: 'http://localhost:8787/api/simple/folders/list',
      description: 'List all folders from R2',
      category: 'API - Files',
      status: 'active',
      method: 'GET'
    },
    {
      url: 'http://localhost:8787/api/upload/request',
      description: 'Request presigned upload URL',
      category: 'API - Files',
      status: 'active',
      method: 'POST'
    },
    {
      url: 'http://localhost:8787/api/upload/direct/:uploadToken',
      description: 'Direct file upload endpoint',
      category: 'API - Files',
      status: 'active',
      method: 'PUT'
    },
    {
      url: 'http://localhost:8787/api/share',
      description: 'Create share link for files',
      category: 'API - Files',
      status: 'active',
      method: 'POST'
    },
    {
      url: 'http://localhost:8787/api/share/:linkId',
      description: 'Get share link details',
      category: 'API - Files',
      status: 'active',
      method: 'GET'
    },
    {
      url: 'http://localhost:8787/api/share/download/:token',
      description: 'Download shared file',
      category: 'API - Files',
      status: 'active',
      method: 'GET'
    },

    // External URLs
    {
      url: 'https://github.com/ideabrian/cf-fullstack-boilerplate',
      description: 'GitHub repository for this project',
      category: 'External Links',
      status: 'external'
    },
    {
      url: 'https://dash.cloudflare.com/profile/api-tokens',
      description: 'CloudFlare dashboard to get API tokens',
      category: 'External Links',
      status: 'external'
    },
    {
      url: 'https://claude.ai/code',
      description: 'Claude Code - AI coding assistant',
      category: 'External Links',
      status: 'external'
    },
    {
      url: 'https://docs.claude.com/en/docs/claude-code/claude_code_docs_map.md',
      description: 'Claude Code documentation',
      category: 'External Links',
      status: 'external'
    },

    // AWS Service URLs
    {
      url: 'feedback-smtp.us-east-1.amazonses.com',
      description: 'AWS SES SMTP endpoint for email routing (MX record)',
      category: 'AWS Services',
      status: 'documentation'
    },
    {
      url: '*.dkim.amazonses.com',
      description: 'AWS SES DKIM verification endpoints',
      category: 'AWS Services',
      status: 'documentation'
    },

    // Example Domains
    {
      url: 'biig.dev',
      description: 'Example domain used throughout the application',
      category: 'Example Domains',
      status: 'documentation'
    },
    {
      url: 'mail.biig.dev',
      description: 'Example MAIL FROM subdomain',
      category: 'Example Domains',
      status: 'documentation'
    },
    {
      url: 'noreply@biig.dev',
      description: 'Example FROM email address',
      category: 'Example Domains',
      status: 'documentation'
    }
  ];

  const categories = ['all', ...Array.from(new Set(links.map(l => l.category)))];

  const filteredLinks = links.filter(link => {
    const matchesCategory = selectedCategory === 'all' || link.category === selectedCategory;
    const matchesSearch = searchTerm === '' ||
      link.url.toLowerCase().includes(searchTerm.toLowerCase()) ||
      link.description.toLowerCase().includes(searchTerm.toLowerCase());
    return matchesCategory && matchesSearch;
  });

  const getStatusColor = (status?: string) => {
    switch (status) {
      case 'active': return 'text-green-400 bg-green-900/30';
      case 'external': return 'text-blue-400 bg-blue-900/30';
      case 'documentation': return 'text-yellow-400 bg-yellow-900/30';
      default: return 'text-gray-400 bg-gray-900/30';
    }
  };

  const getMethodColor = (method?: string) => {
    if (!method) return '';
    if (method.includes('GET')) return 'bg-blue-600';
    if (method.includes('POST')) return 'bg-green-600';
    if (method.includes('PUT')) return 'bg-yellow-600';
    if (method.includes('DELETE')) return 'bg-red-600';
    return 'bg-gray-600';
  };

  const handleCopyUrl = (url: string) => {
    navigator.clipboard.writeText(url);
    // Could add toast notification here
  };

  const handleOpenUrl = (url: string) => {
    if (url.startsWith('http://') || url.startsWith('https://')) {
      window.open(url, '_blank');
    }
  };

  return (
    <div className="min-h-screen bg-gray-900 text-white p-8">
      <div className="max-w-7xl mx-auto">
        <div className="mb-8">
          <h1 className="text-3xl font-bold mb-2">🔗 Links Directory</h1>
          <p className="text-gray-400">Complete directory of all URLs, routes, and endpoints in the system</p>
        </div>

        {/* Stats */}
        <div className="grid grid-cols-4 gap-4 mb-6">
          <div className="bg-gray-800 rounded-lg p-4">
            <p className="text-2xl font-bold">{links.length}</p>
            <p className="text-sm text-gray-400">Total Links</p>
          </div>
          <div className="bg-gray-800 rounded-lg p-4">
            <p className="text-2xl font-bold">{links.filter(l => l.category.includes('Frontend')).length}</p>
            <p className="text-sm text-gray-400">Frontend Routes</p>
          </div>
          <div className="bg-gray-800 rounded-lg p-4">
            <p className="text-2xl font-bold">{links.filter(l => l.category.includes('API')).length}</p>
            <p className="text-sm text-gray-400">API Endpoints</p>
          </div>
          <div className="bg-gray-800 rounded-lg p-4">
            <p className="text-2xl font-bold">{links.filter(l => l.status === 'external').length}</p>
            <p className="text-sm text-gray-400">External Links</p>
          </div>
        </div>

        {/* Filters */}
        <div className="flex gap-4 mb-6">
          <input
            type="text"
            placeholder="Search URLs or descriptions..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            className="flex-1 px-4 py-2 bg-gray-800 rounded border border-gray-700 text-white"
          />
          <select
            value={selectedCategory}
            onChange={(e) => setSelectedCategory(e.target.value)}
            className="px-4 py-2 bg-gray-800 rounded border border-gray-700 text-white"
          >
            {categories.map(cat => (
              <option key={cat} value={cat}>
                {cat === 'all' ? 'All Categories' : cat}
              </option>
            ))}
          </select>
        </div>

        {/* Links Table */}
        <div className="bg-gray-800 rounded-lg overflow-hidden">
          <table className="w-full">
            <thead className="bg-gray-900">
              <tr>
                <th className="text-left p-4">URL</th>
                <th className="text-left p-4">Description</th>
                <th className="text-left p-4">Category</th>
                <th className="text-left p-4">Method</th>
                <th className="text-left p-4">Status</th>
                <th className="text-left p-4">Actions</th>
              </tr>
            </thead>
            <tbody>
              {filteredLinks.map((link, index) => (
                <tr key={index} className="border-t border-gray-700 hover:bg-gray-700/50">
                  <td className="p-4">
                    <code className="text-xs text-blue-400 break-all">{link.url}</code>
                  </td>
                  <td className="p-4 text-sm">{link.description}</td>
                  <td className="p-4">
                    <span className="text-xs px-2 py-1 bg-gray-700 rounded">
                      {link.category}
                    </span>
                  </td>
                  <td className="p-4">
                    {link.method && (
                      <span className={`text-xs px-2 py-1 rounded text-white ${getMethodColor(link.method)}`}>
                        {link.method}
                      </span>
                    )}
                  </td>
                  <td className="p-4">
                    <span className={`text-xs px-2 py-1 rounded ${getStatusColor(link.status)}`}>
                      {link.status || 'internal'}
                    </span>
                  </td>
                  <td className="p-4">
                    <div className="flex gap-2">
                      <button
                        onClick={() => handleCopyUrl(link.url)}
                        className="text-xs px-2 py-1 bg-gray-600 rounded hover:bg-gray-500"
                        title="Copy URL"
                      >
                        📋
                      </button>
                      {(link.url.startsWith('http://') || link.url.startsWith('https://')) && (
                        <button
                          onClick={() => handleOpenUrl(link.url)}
                          className="text-xs px-2 py-1 bg-gray-600 rounded hover:bg-gray-500"
                          title="Open URL"
                        >
                          🔗
                        </button>
                      )}
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        {/* Quick Access Sections */}
        <div className="mt-8 grid grid-cols-2 gap-6">
          <div className="bg-gray-800 rounded-lg p-6">
            <h2 className="text-xl font-bold mb-4">🚀 Quick Access - Frontend</h2>
            <div className="space-y-2">
              <a href="/folder-steps" className="block text-blue-400 hover:text-blue-300">
                → Step-by-Step Folder Creation
              </a>
              <a href="/iam-setup" className="block text-blue-400 hover:text-blue-300">
                → IAM Permission Palace
              </a>
              <a href="/send-email" className="block text-blue-400 hover:text-blue-300">
                → Email Sender
              </a>
              <a href="/domains" className="block text-blue-400 hover:text-blue-300">
                → Domain Manager
              </a>
            </div>
          </div>

          <div className="bg-gray-800 rounded-lg p-6">
            <h2 className="text-xl font-bold mb-4">🔧 Quick Access - API Testing</h2>
            <div className="space-y-2">
              <div className="text-sm">
                <p className="text-gray-400 mb-1">Health Check:</p>
                <code className="text-xs">curl http://localhost:8787/api/health</code>
              </div>
              <div className="text-sm">
                <p className="text-gray-400 mb-1">List Folders:</p>
                <code className="text-xs">curl http://localhost:8787/api/simple/folders/list</code>
              </div>
              <div className="text-sm">
                <p className="text-gray-400 mb-1">Create Folder:</p>
                <code className="text-xs">curl -X POST http://localhost:8787/api/simple/folders/create -d '{`{"clientName":"test"}`}'</code>
              </div>
            </div>
          </div>
        </div>

        {/* Legend */}
        <div className="mt-8 p-4 bg-gray-800 rounded-lg">
          <h3 className="font-bold mb-2">📖 Legend</h3>
          <div className="flex gap-6 text-sm">
            <span className="text-green-400">● Active - Currently running</span>
            <span className="text-blue-400">● External - External service</span>
            <span className="text-yellow-400">● Documentation - Example/reference</span>
            <span className="text-gray-400">● Internal - System route</span>
          </div>
        </div>
      </div>
    </div>
  );
};